// extracted by mini-css-extract-plugin
export default {"MainButton":"Button_MainButton__RsG7s"};